
import { fetch, addTask } from 'domain-task';
import { Action, Reducer, ActionCreator } from 'redux';
import { AppThunkAction } from './';

import { RCUtils } from './../RCUtils';
import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
import $ from 'jquery';
var Config: any = require('../Config.json');

export interface AdminCargoCareSettingsState {
    params: CargoCareSettingsParams,
    cargoCareSettingsData: CargoCareSettingsData,
    cargoCareSeverity: CargoCareSeverity[],
    bookingTempUnits: BookingTempUnits[],
    userLoginGeofences: UserLoginGeofences[],
    userLoginAGGGeofences: UserLoginGeofences[],
    isLoading: boolean
}
export class CargoCareSettingsParams {
    CustomerId: number;
    UserId: number;
    CustomerTypeCd: string;
}
export class CargoCareSettingsData {
    TempSevere: string;
    TempMinor: string;
    TempInformational: string;
    IsSevere: boolean;
    IsMinor: boolean;
    IsInformational: boolean;
    SevereReportingInterval: string;
    MinorReportingInterval: string;
    InfReportingInterval: string;
    IsMissingSchedule: boolean;
    MissingScheduleInterval: string;
    SeveritySelectedValue: any;
    IsBatteryPower: boolean;
    OffPowerInterval: string;
    BatterySeveritySelectedValue: any;
    CustTypeCd: string;
    CustomerID?: number;
    UserID?: number;

    IsMissingScheduleGenset: boolean;
    IsMissingScheduleDry: boolean;
    MissingScheduleIntervalGenset: string;
    MissingScheduleIntervalDry: string;
    CCDefrostCheck: boolean;

    //WI 26439
    IsGeofences?: boolean;
}

export class RefCargoCareParam {
    CargoCareParamID: number;
    CargoCareParamCode: string;
    DefaultValue: number;
}
export class CargoCareSeverity {
    SeverityStateID: number;
    SeverityStateCode: string;
}
export class BookingTempUnits {
    BookTempAlertUnitsCode: string;
    BookTempAlertUnitsValue: string;
}
export class UserLoginGeofences {
    GeofenceID: number;
    FenceID: number;
    Name: string;
    Tag: string;
    GeofenceCategoryCd: string;
}

export class CargoCareSettingsGeofences {
    CustomerProfileId: number;
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface RequestCargoCareSettingsDataAction {
    type: 'REQUEST_ADMIN_CARGOCARESETTINGS';
    params: CargoCareSettingsParams;
}

interface ReceiveCargoCareSettingsDataAction {
    type: 'RECEIVE_ADMIN_CARGOCARESETTINGS';
    params: CargoCareSettingsParams;
    cargoCareSettingsData: CargoCareSettingsData;
}
interface SubmitCargoCareSettingsDataAction {
    type: 'SUBMIT_ADMIN_CARGOCARESETTINGS';
    params: CargoCareSettingsParams;
    cargoCareSettingsData: CargoCareSettingsData;

}
interface ReceiveCargoCareSeverityDataAction {
    type: 'RECEIVE_ADMIN_CARGOCARESEVERITY';
    cargoCareSeverityData: CargoCareSeverity[];
}
interface ReceiveBookingTempUnitsDataAction {
    type: 'RECEIVE_ADMIN_BOOKINGTEMPUNITS';
    bookingTempUnitsData: BookingTempUnits[];
}
interface RequestUserGeofencesForCCSettings {
    type: 'RECEIVE_ADMIN_USERGEOFENCES';
    userGeofencesData: UserLoginGeofences[];
}
interface RequestUserAGGGeofencesForCCSettings {
    type: 'RECEIVE_ADMIN_USERAGGGEOFENCES';
    userAGGGeofencesData: UserLoginGeofences[];
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction = RequestCargoCareSettingsDataAction | ReceiveCargoCareSettingsDataAction | SubmitCargoCareSettingsDataAction | ReceiveCargoCareSeverityDataAction | ReceiveBookingTempUnitsDataAction | RequestUserGeofencesForCCSettings | RequestUserAGGGeofencesForCCSettings;
// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
export const actionCreators = {
    RequestCargoCareSettingsData: (params: CargoCareSettingsParams): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)
        if (params !== getState().cargoCareSettingsData.params) {
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/AdminCargoCareSettings/CargoCareSettingsUI', { method: 'POST', body: JSON.stringify(params), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
            let fetchTask = fetch(request)
                .then(RCUtils.handleError)
                .then((response => response.json() as Promise<CargoCareSettingsData>))
                .then(data => {
                    dispatch({ type: 'RECEIVE_ADMIN_CARGOCARESETTINGS', params: params, cargoCareSettingsData: data });
                });

            addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
            dispatch({ type: 'REQUEST_ADMIN_CARGOCARESETTINGS', params: params });
        }
    },
    SubmitCargoCareSettingsData: (cargoCareSettingsData: CargoCareSettingsData): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)
        if (cargoCareSettingsData !== getState().cargoCareSettingsData.cargoCareSettingsData) {
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/AdminCargoCareSettings/SaveCargoCareSettings', { method: 'POST', body: JSON.stringify(cargoCareSettingsData), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
            let fetchTask = fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    $('#globalLoader').hide();
                    dispatch({ type: 'RECEIVE_ADMIN_CARGOCARESETTINGS', params: getState().cargoCareSettingsData.params, cargoCareSettingsData: cargoCareSettingsData });
                    if (data == "CargoCare details updated successfully.")
                        PopupWindow.showErrorMessage("Confirmation", data);
                    else
                        PopupWindow.showErrorMessage("Error", data);
                });
        }
    },
    RequestCargoCareSeverityData: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/AdminCargoCareSettings/GetRefSeverityCategories', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<CargoCareSeverity[]>)
            .then(data => {
                dispatch({ type: 'RECEIVE_ADMIN_CARGOCARESEVERITY', cargoCareSeverityData: data });
            });
    },
    RequestBookingTempUnitsData: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/AdminCargoCareSettings/GetRefBookTempAlertUnits', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<BookingTempUnits[]>)
            .then(data => {
                dispatch({ type: 'RECEIVE_ADMIN_BOOKINGTEMPUNITS', bookingTempUnitsData: data });
            });
    },
    RequestUserGeofencesForCCSettings: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/AdminCargoCareSettings/GetUserGeofencesForCCSettings', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<UserLoginGeofences[]>)
            .then(data => {
                dispatch({ type: 'RECEIVE_ADMIN_USERGEOFENCES', userGeofencesData: data });
            });
    },
    RequestUserAGGGeofencesForCCSettings: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/AdminCargoCareSettings/GetUserSelectedGeofencesForCC', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<UserLoginGeofences[]>)
            .then(data => {
                dispatch({ type: 'RECEIVE_ADMIN_USERAGGGEOFENCES', userAGGGeofencesData: data });
            });
    }
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
const emptyCargoCareSettingsParams = { CustomerId: 0, UserId: 0, CustomerTypeCd: 'SO' };
const emptycargoCareSeverity = [{ SeverityStateID: 1, SeverityStateCode: "Severe" }];
const emptyBookingTempUnits = [{ BookTempAlertUnitsCode: "", BookTempAlertUnitsValue: "" }];
const emptyUserLoginGeofences = [{ GeofenceID: 0, FenceID: 0, Name: "", Tag: "", GeofenceCategoryCd: "" }];
const emptyUserLoginAGGGeofences = [{ GeofenceID: 0, FenceID: 0, Name: "", Tag: "", GeofenceCategoryCd: "" }];

const unloadedState: AdminCargoCareSettingsState = {
    cargoCareSettingsData: new CargoCareSettingsData(), params: emptyCargoCareSettingsParams, cargoCareSeverity: emptycargoCareSeverity,
    bookingTempUnits: emptyBookingTempUnits, userLoginGeofences: emptyUserLoginGeofences, userLoginAGGGeofences: emptyUserLoginAGGGeofences, isLoading: true
};

export const reducer: Reducer<AdminCargoCareSettingsState> = (state: AdminCargoCareSettingsState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_ADMIN_CARGOCARESETTINGS':
            return {
                params: action.params,
                cargoCareSettingsData: state.cargoCareSettingsData,
                cargoCareSeverity: state.cargoCareSeverity,
                bookingTempUnits: state.bookingTempUnits,
                userLoginGeofences: state.userLoginGeofences,
                userLoginAGGGeofences: state.userLoginAGGGeofences,
                isLoading: true
            };
        case 'SUBMIT_ADMIN_CARGOCARESETTINGS':
            return {
                params: action.params,
                cargoCareSettingsData: state.cargoCareSettingsData,
                cargoCareSeverity: state.cargoCareSeverity,
                bookingTempUnits: state.bookingTempUnits,
                userLoginGeofences: state.userLoginGeofences,
                userLoginAGGGeofences: state.userLoginAGGGeofences,
                isLoading: true
            };
        case 'RECEIVE_ADMIN_CARGOCARESEVERITY':
            return {
                params: state.params,
                cargoCareSettingsData: state.cargoCareSettingsData,
                cargoCareSeverity: action.cargoCareSeverityData,
                bookingTempUnits: state.bookingTempUnits,
                userLoginGeofences: state.userLoginGeofences,
                userLoginAGGGeofences: state.userLoginAGGGeofences,
                isLoading: false
            };
        case 'RECEIVE_ADMIN_BOOKINGTEMPUNITS':
            return {
                params: state.params,
                cargoCareSettingsData: state.cargoCareSettingsData,
                cargoCareSeverity: state.cargoCareSeverity,
                bookingTempUnits: action.bookingTempUnitsData,
                userLoginGeofences: state.userLoginGeofences,
                userLoginAGGGeofences: state.userLoginAGGGeofences,
                isLoading: false
            };
        case 'RECEIVE_ADMIN_USERGEOFENCES':
            return {
                params: state.params,
                cargoCareSettingsData: state.cargoCareSettingsData,
                cargoCareSeverity: state.cargoCareSeverity,
                bookingTempUnits: state.bookingTempUnits,
                userLoginGeofences: action.userGeofencesData,
                userLoginAGGGeofences: state.userLoginAGGGeofences,
                isLoading: false
            };
        case 'RECEIVE_ADMIN_USERAGGGEOFENCES':
            return {
                params: state.params,
                cargoCareSettingsData: state.cargoCareSettingsData,
                cargoCareSeverity: state.cargoCareSeverity,
                bookingTempUnits: state.bookingTempUnits,
                userLoginGeofences: state.userLoginGeofences,
                userLoginAGGGeofences: action.userAGGGeofencesData,
                isLoading: false
            };
        case 'RECEIVE_ADMIN_CARGOCARESETTINGS':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            if (action.params === state.params) {
                return {
                    params: action.params,
                    cargoCareSettingsData: action.cargoCareSettingsData,
                    cargoCareSeverity: state.cargoCareSeverity,
                    bookingTempUnits: state.bookingTempUnits,
                    userLoginGeofences: state.userLoginGeofences,
                    userLoginAGGGeofences: state.userLoginAGGGeofences,
                    isLoading: false
                };
            };

            break;
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};